/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 供应商重启申请列表 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/getList`
 */
const postGetListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/getList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 供应商重启申请列表 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/getList`
 */
export const postGetList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetListRequestConfig, requestData), ...args);
};
postGetList.requestConfig = postGetListRequestConfig;
/**
 * 接口 获取筛选条件 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/condition`
 */
const postConditionRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/condition",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCondition",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取筛选条件 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/condition`
 */
export const postCondition = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postConditionRequestConfig, requestData), ...args);
};
postCondition.requestConfig = postConditionRequestConfig;
/**
 * 接口 中台审核 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/ztCheck`
 */
const postZtCheckRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/ztCheck",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postZtCheck",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 中台审核 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/ztCheck`
 */
export const postZtCheck = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postZtCheckRequestConfig, requestData), ...args);
};
postZtCheck.requestConfig = postZtCheckRequestConfig;
/**
 * 接口 买手审核 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/msCheck`
 */
const postMsCheckRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/msCheck",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postMsCheck",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 买手审核 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/msCheck`
 */
export const postMsCheck = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postMsCheckRequestConfig, requestData), ...args);
};
postMsCheck.requestConfig = postMsCheckRequestConfig;
/**
 * 接口 采购驳回 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/cgCheck`
 */
const postCgCheckRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/cgCheck",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postCgCheck",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 采购驳回 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/cgCheck`
 */
export const postCgCheck = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postCgCheckRequestConfig, requestData), ...args);
};
postCgCheck.requestConfig = postCgCheckRequestConfig;
/**
 * 接口 重启商家 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/reopen`
 */
const postReopenRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/reopen",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postReopen",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 重启商家 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/reopen`
 */
export const postReopen = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postReopenRequestConfig, requestData), ...args);
};
postReopen.requestConfig = postReopenRequestConfig;
/**
 * 接口 查看日志 的 **请求配置**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/logs`
 */
const postLogsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/SupplyReopenRecord/logs",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postLogs",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 查看日志 的 **请求函数**
 *
 * @分类 商家API/商家重启申请
 * @请求头 `POST /erp/SupplyReopenRecord/logs`
 */
export const postLogs = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postLogsRequestConfig, requestData), ...args);
};
postLogs.requestConfig = postLogsRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/supplyReopenRecord.js